import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imNotloggedMenu', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/notlogged_menu/notlogged_menu.html'),
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/notlogged_menu/notlogged_menu.component.ts